import { render, staticRenderFns } from "./ProfileManagement.vue?vue&type=template&id=2af66d46&"
import script from "./ProfileManagement.vue?vue&type=script&lang=js&"
export * from "./ProfileManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports